export default __webpack_public_path__ + "static/media/financiamiento.1572c26b.jpg";